import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const ChevronRightIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

export default ChevronRightIcon;
